export default "__VITE_ASSET__B0K05gbV__"